var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1566",
    "data-name": "Group 1566",
    transform: "translate(-474 -3764)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 12.5,
    cy: 12,
    rx: 12.5,
    ry: 12,
    transform: "translate(474 3764)",
    fill: "#ac9788"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(484 3782)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Alice-Regular, Alice"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.0bd82e3d2ab5d6bcafffabba36587777.svg";
export { ForwardRef as ReactComponent };